export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/recording-icon.svg?b1d6bd8fb121f44fcd3fce6b82fa2d6d";